import { TOURNAMENT_GAME_RESULT, TOURNAMENT_GAME_RESULT_SCORE, TOURNAMENT_GAME_RESULT_TEXT, } from "../constants";
export const randomGameResult = () => {
    const r = Math.random();
    if (r < 0.4) {
        return {
            whiteResult: TOURNAMENT_GAME_RESULT.WIN,
            blackResult: TOURNAMENT_GAME_RESULT.LOSS,
        };
    }
    if (r < 0.8) {
        return {
            whiteResult: TOURNAMENT_GAME_RESULT.LOSS,
            blackResult: TOURNAMENT_GAME_RESULT.WIN,
        };
    }
    return {
        whiteResult: TOURNAMENT_GAME_RESULT.DRAW,
        blackResult: TOURNAMENT_GAME_RESULT.DRAW,
    };
};
export const hasPlayerMismatch = (game) => {
    if (!game.matchRef)
        return false;
    if (!game.matchRef.player1 && game.whiteUsername)
        return true;
    if (!game.matchRef.player2 && game.blackUsername)
        return true;
    if (game.matchRef.player1 &&
        game.matchRef.player1.username !== game.whiteUsername) {
        return true;
    }
    return !!(game.matchRef.player2 &&
        game.matchRef.player2.username !== game.blackUsername);
};
export const isCompleted = (game) => {
    return (game.matchRef &&
        game.matchRef.result &&
        game.matchRef.status !== "aborted" &&
        !hasPlayerMismatch(game));
};
export const isUnfinished = (game) => {
    return (game.whiteResult == TOURNAMENT_GAME_RESULT.UNFINISHED ||
        game.blackResult == TOURNAMENT_GAME_RESULT.UNFINISHED);
};
export const tournamentResultScore = (resultEnum) => {
    if (resultEnum == null)
        return 0;
    return TOURNAMENT_GAME_RESULT_SCORE[resultEnum];
};
export const tournamentResultText = (resultEnum) => {
    if (resultEnum == null)
        return "";
    return TOURNAMENT_GAME_RESULT_TEXT[resultEnum];
};
export const scoreText = (whiteScore, blackScore) => {
    if (whiteScore == null || blackScore == null)
        return "";
    return `${whiteScore === 0.5 ? "½" : whiteScore} - ${blackScore === 0.5 ? "½" : blackScore}`;
};
export const resultText = (whiteScore, blackScore, result) => {
    let s1 = "";
    switch (result) {
        case "abort":
            s1 = "Game aborted.";
            break;
        case "player_abort":
            s1 = "Player aborted.";
            break;
        case "white_abort":
            s1 = "White aborted.";
            break;
        case "black_abort":
            s1 = "Black aborted.";
            break;
        case "forfeit":
            s1 = `${whiteScore === 1 ? "Black" : blackScore === 1 ? "White" : "Both"} forfeited.`;
            break;
        case "checkmate":
            s1 = "Checkmate.";
            break;
        case "stalemate":
            s1 = "Stalemate.";
            break;
        case "threefold_repetition":
            s1 = "The current board position has occurred three or more times.";
            break;
        case "insufficient_material":
            s1 = "Insufficient material.";
            break;
        case "draw":
            s1 = "50 moves have been made by each player without a capture or pawn move.";
            break;
        case "timeout":
            if (whiteScore === 1)
                s1 = "Black timed out.";
            else if (blackScore === 1)
                s1 = "White timed out.";
            else
                s1 = "A player timed out.";
            break;
        case "white_timeout_vs_insufficient":
            s1 =
                "White ran out of time, but Black has insufficient material to checkmate.";
            break;
        case "black_timeout_vs_insufficient":
            s1 =
                "Black ran out of time, but White has insufficient material to checkmate.";
            break;
        case "bare king":
            s1 =
                "One player ran out of time, but the other player has insufficient material to checkmate.";
            break;
        case "resign":
            s1 = `${whiteScore === 1 ? "Black" : "White"} resigned.`;
            break;
        case "draw by agreement":
            s1 = "Draw by agreement.";
            break;
        case "disqualified":
            s1 = `${whiteScore === 1
                ? "Black has"
                : blackScore === 1
                    ? "White has"
                    : "Both have"} been disqualified due to violation of the Fair Play rules.`;
            break;
        case "invalid":
            s1 = "The match was invalidated";
            break;
        default:
            break;
    }
    let s2 = "";
    if (whiteScore === 1)
        s2 = "White is victorious";
    else if (blackScore === 1)
        s2 = "Black is victorious";
    else if (whiteScore === 0.5)
        s2 = "The game is drawn";
    return `${s1}
    ${s2}`;
};
/** Returns the FEN-letter pieces for the given color from a FEN string. */
export const piecesInFen = (fen, color) => {
    if (!fen)
        return [];
    const rowsFen = fen.split(" ")[0];
    if (!rowsFen)
        return [];
    if (color === "white")
        return rowsFen.match(/[KQRBNP]/g) || [];
    if (color === "black")
        return rowsFen.match(/[kqrbnp]/g) || [];
    return [];
};
/**
 * True if `color` cannot possibly deliver checkmate from the given position:
 * lone king, or king + single knight/bishop. Used to decide draw-on-timeout per FIDE 6.9.
 */
export const hasInsufficientMatingMaterial = (fen, color) => {
    const pieces = piecesInFen(fen, color);
    if (pieces.length === 1)
        return true; // bare king
    if (pieces.length === 2) {
        const types = pieces.map((c) => c.toUpperCase());
        if (types.includes("N") || types.includes("B"))
            return true; // K+N or K+B
    }
    return false;
};
/** Formats a chess evaluation score. Returns mate notation (#N) when mateValue is set, centipawn score otherwise. */
export const asChessEvalScore = (score, mateValue) => {
    if (mateValue !== null && mateValue !== undefined) {
        return `#${mateValue}`;
    }
    if (score === null || score === undefined)
        return "";
    return (score / 100).toFixed(1);
};
